// src/pages/layout/Navbar.jsx
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

export default function Navbar({ toggleSidebar }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.username) {
      setUsername(user.username);
    }
  }, []);

  // Tutup dropdown kalau klik di luar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <nav className="navbar navbar-header navbar-expand navbar-light">
      <a
        href="#"
        className="sidebar-toggler"
        onClick={(e) => {
          e.preventDefault();
          toggleSidebar();
        }}
      >
        <span className="navbar-toggler-icon"></span>
      </a>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav d-flex align-items-center navbar-light ml-auto">
          <li className="nav-item dropdown" ref={dropdownRef}>
            <button
              className="nav-link nav-link-lg nav-link-user bg-transparent border-0 p-0 d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => setDropdownOpen((prev) => !prev)}
            >
              <div className="avatar mr-1"></div>
              <div className="d-none d-md-block d-lg-inline-block">
                Hi, {username || "User"}
              </div>
            </button>

            {dropdownOpen && (
              <div className="dropdown-menu dropdown-menu-right show">
                <a className="dropdown-item" href="#">
                  Account
                </a>
                <div className="dropdown-divider"></div>
                <button
                  className="dropdown-item text-danger"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
}
